import { MyTenantsResult, TenantFeatures } from "breuer-supercharged-sdk";
import { useCallback } from "react";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { queryClient } from "../main";
import { findRefreshedTenant, tenantHasFeature } from "./tenant_refresh";

interface TenantState {
  selectedTenant: MyTenantsResult | null;
  availableTenants: MyTenantsResult[];
  isLoading: boolean;
  setSelectedTenant: (tenant: MyTenantsResult | null) => void;
  setAvailableTenants: (tenants: MyTenantsResult[]) => void;
  refreshSelectedTenant: (tenants: MyTenantsResult[]) => void;
  setIsLoading: (isLoading: boolean) => void;
  clearTenantData: () => void;
  hasFeature: (feature: TenantFeatures) => boolean;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set, get) => ({
      selectedTenant: null,
      availableTenants: [],
      isLoading: false,
      setSelectedTenant: (tenant) => {
        queryClient.clear();

        set({ selectedTenant: tenant });
        // if (!tenant) {
        //     localStorage.removeItem('x-tenant-id');
        // } else {
        //     localStorage.setItem('x-tenant-id', tenant!.tenantId);
        // }
      },
      setAvailableTenants: (tenants) => set({ availableTenants: tenants }),
      // Unlike setSelectedTenant this keeps the query cache: same tenant, only fresher data (e.g. features).
      refreshSelectedTenant: (tenants) => {
        const refreshed = findRefreshedTenant(get().selectedTenant, tenants);
        if (refreshed) set({ selectedTenant: refreshed });
      },
      setIsLoading: (isLoading) => set({ isLoading }),
      clearTenantData: () =>
        set({
          selectedTenant: null,
          availableTenants: [],
          isLoading: false,
        }),
      hasFeature: (feature: TenantFeatures) => tenantHasFeature(get().selectedTenant, feature),
    }),
    {
      name: "tenant-storage",
      partialize: (state) => ({
        selectedTenant: state.selectedTenant,
      }),
    }
  )
);

export function getTenantSelectedId(): string | null {
  return useTenantStore.getState().selectedTenant?.tenantId ?? null;
}

// Depends on selectedTenant (not the stable store function), so React Compiler memos recompute when features change.
export function useHasFeature(): (feature: TenantFeatures) => boolean {
  const selectedTenant = useTenantStore((state) => state.selectedTenant);
  return useCallback((feature: TenantFeatures) => tenantHasFeature(selectedTenant, feature), [selectedTenant]);
}
